import EmailVerificationForm from '../../modules/auth/UI/EmailVerification';

function EmailVerificationPage() {
  return <EmailVerificationForm />;
}

export default EmailVerificationPage;
